import axios from 'axios';
import { IRequest } from '~/types/requests';

const getRequestsList = async () => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/requests/list`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data?.list;
};

const getWorksiteRequests = async (id: string) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/requests/worksite/${id}`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data?.requests;
};

const createRequest = async (data: Partial<IRequest>): Promise<{ request: IRequest }> => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/requests`,
    data,
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return response.data;
};

const exportRequest = async (id: string, filename: string | null) => {
  const token = localStorage.getItem('token');
  if (!token) return null;

  const { data, headers } = await axios.get(
    `${process.env.REACT_APP_API_URL}/requests/export/${id}`,
    {
      headers: {
        Authorization: token,
      },
      responseType: 'blob',
    },
  );
  // Récupérer le filename depuis le header Content-Disposition
  const contentDisposition = headers['content-disposition'];
  let apiFilename = filename; // Utiliser le filename passé en paramètre par défaut

  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
    if (filenameMatch) {
      [, apiFilename] = filenameMatch;
    }
  }
  console.log(headers);
  const fileURL = URL.createObjectURL(data);
  if (filename) {
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = filename; // Set filename for download
    link.click();
  } else if (apiFilename) {
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = apiFilename; // Set filename for download
    link.click();
  } else {
    window.open(fileURL, '_blank');
  }
  setTimeout(() => URL.revokeObjectURL(fileURL), 100);
  return data;
};

export {
  getRequestsList,
  createRequest,
  getWorksiteRequests,
  exportRequest,
};
